(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.teasers = {
    attach: function (context, settings) {
      const $teaserButton = $('.js-teaser__view-more', context);
      const $faqButton = $('.js-teaser-content__header', context);
      const $accordionButton = $('.js-accordion-button', context);
      const $termsButton = $('.js-terms-button', context);
      const $flexAccordionButton = $('.node__content--flex .js-accordion-button', context);
      const $mobileFilterButton = $('.js-mobile-filter-button', context);

      $teaserButton.on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).text('View full meeting notes');
          $(this).closest('.teaser__content').find('.teaser-content__expand').removeClass('active');
        } else {
          $(this).addClass('active');
          $(this).text('Hide full meeting notes');
          $(this).closest('.teaser__content').find('.teaser-content__expand').addClass('active');
        }
      });

      $faqButton.on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).closest('.teaser__content').find('.teaser-content__expand').removeClass('active');
        } else {
          $(this).addClass('active');
          $(this).closest('.teaser__content').find('.teaser-content__expand').addClass('active');
        }
      });

      $accordionButton.on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).closest('.accordion__wrapper').find('.js-accordion-expand').removeClass('active');
        } else {
          $(this).addClass('active');
          $(this).closest('.accordion__wrapper').find('.js-accordion-expand').addClass('active');
        }
      });

      // This is here because the terms & conditions slider functions exactly like a hidden teaser
      $termsButton.on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $(this).text('Show');
          $(this).closest('.node__content').find('.terms__body').removeClass('active');
        } else {
          $(this).addClass('active');
          $(this).text('Hide');
          $(this).closest('.node__content').find('.terms__body').addClass('active');
        }
      });

      // Checks if page loaded is the flexible content template and opens first accordion on page load
      if ($('.node__content--flex')) {
        $flexAccordionButton.first().addClass('active');
        $flexAccordionButton.first().closest('.accordion__wrapper').find('.js-accordion-expand').addClass('active');
      }

      // Mobile filter button works the same way as the accordion button
      $mobileFilterButton.on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          $('span', this).removeClass('active');
          $(this).closest('.view__aside').find('.views-exposed-form').removeClass('active');
        } else {
          $(this).addClass('active');
          $('span', this).addClass('active');
          $(this).closest('.view__aside').find('.views-exposed-form').addClass('active');
        }
      });
    }
  };
})(jQuery, Drupal);
